import { Scissors, Trash2 } from "lucide-react";
import { sectionsOf } from "@/lib/reportSection";

import { tr } from "@/lib/i18n";
// quote dei gruppi di moduli e linee di sezione (una per falda)
export const MarksPanel = ({ ed, layout, commit, flat }) => {
  const secs = flat ? [] : sectionsOf(layout);
  const drop = (id) => commit((prev) => ({ roofs: prev.roofs.map((r) => (r.id === id ? { ...r, section: null } : r)) }));
  return (
    <div className="space-y-2 text-xs" data-testid="editor-marks">
      <label className="flex items-center gap-2 cursor-pointer">
        <input type="checkbox" className="accent-[#0F52BA]" checked={ed.showGroupDims} onChange={(e) => ed.setShowGroupDims(e.target.checked)} data-testid="editor-toggle-group-dims" />
        {flat ? tr("Quote delle file di moduli (lunghezza, n° moduli) e spazio libero tra le file") : tr("Quote dei gruppi di moduli (larghezza lungo gronda, lunghezza lungo falda, righe × colonne)")}
      </label>
      {!flat && (
        <>
          <button onClick={() => ed.setTool(ed.tool === "section" ? "select" : "section")} data-testid="editor-add-section"
            className={`w-full h-8 rounded-md border text-xs flex items-center justify-center gap-1.5 ${ed.tool === "section" ? "bg-[#0F52BA] text-white border-[#0F52BA]" : "border-slate-200 text-slate-600 hover:bg-slate-50"}`}>
            <Scissors className="w-3.5 h-3.5" />{tr("Linea di sezione: clicca sulla falda")}
          </button>
          {secs.map((sc) => (
            <div key={sc.f.roof.id} className="flex items-center justify-between rounded border border-slate-200 px-2 py-1" data-testid={`editor-section-${sc.letter}`}>
              <span><b className="text-red-600">{sc.letter}–{sc.letter}</b> · {sc.f.roof.name}</span>
              <button onClick={() => drop(sc.f.roof.id)} title={tr("Rimuovi la linea di sezione")} data-testid={`editor-section-remove-${sc.letter}`} className="text-slate-400 hover:text-red-600"><Trash2 className="w-3.5 h-3.5" /></button>
            </div>
          ))}
          <p className="text-slate-400">{tr("Ogni linea diventa una pagina \"Sezione\" nel report. Trascina la linea per spostarla lungo la gronda.")}</p>
        </>
      )}
    </div>
  );
};
